import { Route } from "vue-router";
import { getModule } from "vuex-module-decorators";
import TitleListState from "@/modules/title-list";

export const LFSearchResolver = async function (to: Route, form: Route, next: Function) {
	const titleListModule = getModule(TitleListState);
	const actions: Promise<void>[] = [];

	if (!titleListModule.levels.length) {
		actions.push(titleListModule.fetchVcsLevels());
	}
	if (!titleListModule.tags.length) {
		actions.push(titleListModule.fetchVcsTags());
	}

	await Promise.all(actions);
	next();
};
